/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {syncRejectedDepositAttemptWithLit} from '../api'

export const useMutationSyncRejectedDepositAttemptWithLit = createReactQueryMutationHook('syncRejectedDepositAttemptWithLit', syncRejectedDepositAttemptWithLit)
